import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * CareersPage - HIDDEN/DISABLED
 * This page is intentionally disabled and returns 404/redirect.
 * Staff job postings are managed internally via /admin/jobs (Super Admin only).
 * Publishing to public /careers will be enabled in a future release.
 * 
 * SEO: noindex meta tag included if this page ever renders
 */
const CareersPage = () => {
  // Redirect to home - page is not public
  return <Navigate to="/" replace />;
};

export default CareersPage;
